export const BookingsTimeseriesChartSkeleton = () => {
  return (
    <div className="flex flex-col flex-1">
      <div className="flex items-center justify-between h-[56px] gap-4">
        <div className="h-[30px] w-full animate-pulse rounded-sm flex flex-1 bg-gray-200" />
        <div className="h-[30px] w-[30px] animate-pulse rounded-sm bg-gray-200" />
      </div>

      <div className="flex flex-col items-center justify-center gap-6">
        <div className="h-[250px] w-full animate-pulse rounded-sm bg-gray-200" />
      </div>
    </div>
  );
};
